import React from 'react';
import StoreExtensionResponseFilters from 'stores/storeExtensionResponseFilters';
import StoreWebhookErrorFilters from 'stores/storeWebhookErrorFilters';
import StoreExtensionGlobalVariableFilters from 'stores/storeExtensionGlobalVariableFilters';
import StoreRulesFilters from 'stores/storeRulesFilters';
import StoreRuleVersionFilters from 'stores/storeRuleVersionFilters';
import StoreRulePublishHistoryFilters from 'stores/storeRuleVersionFilters';
import StoreProcessConnectionFilters from 'stores/storeProcessConnectionFilters';
import StoreAlertFilters from 'stores/storeAlertFilters';
import StoreSuppressionRulesFilters from 'stores/storeSuppressionRulesFilters';
import StoreSuppressionRuleVersionFilters from 'stores/storeSuppressionRuleVersionFilters';
import StoreSuppressionRulePublishHistoryFilters from 'stores/storeSuppressionRuleVersionFilters';
import rootStore from 'stores/index';
import StoreAddressIssuesFilters from 'stores/storeAddressIssuesFilters';

export const storesContext = React.createContext({
    boxStore: rootStore.boxStore,
    reportStore: rootStore.reportStore,
    authStore: rootStore.authStore,
    searchStore: rootStore.searchStore,
    licenseStore: rootStore.licenseStore,
    agentListStore: rootStore.agentListStore,
    taskListStore: rootStore.taskListStore,
    targetGroupListStore: rootStore.targetGroupListStore,
    accessTokenListStore: rootStore.accessTokenListStore,
    personalAccessTokenListStore: rootStore.personalAccessTokenListStore,
    userListStore: rootStore.userListStore,
    userActivityListStore: rootStore.userActivityListStore,
    licenseAuditListStore: rootStore.licenseAuditListStore,
    extensionListStore: rootStore.extensionListStore,
    extensionVersionListStore: rootStore.extensionVersionListStore,
    extensionResultListStore: rootStore.extensionResultListStore,
    extensionAggregationListStore: rootStore.extensionAggregationListStore,
    historySearchListStore: rootStore.historySearchListStore,
    processListStore: rootStore.processListStore,
    moduleListStore: rootStore.moduleListStore,
    autostartListStore: rootStore.autostartListStore,
    driverListStore: rootStore.driverListStore,
    artifactListStore: rootStore.artifactListStore,
    accountListStore: rootStore.accountListStore,
    accountSearchListStore: rootStore.accountSearchListStore,
    scriptListStore: rootStore.scriptListStore,
    scriptSearchListStore: rootStore.scriptSearchListStore,
    webhookListStore: rootStore.webhookListStore,
    hostListStore: rootStore.hostListStore,
    hostSearchListStore: rootStore.hostSearchListStore,
    memoryListStore: rootStore.memoryListStore,
    memorySearchListStore: rootStore.memorySearchListStore,
    connectionListStore: rootStore.connectionListStore,
    connectionSearchListStore: rootStore.connectionSearchListStore,
    controllerListStore: rootStore.controllerListStore,
    agentRegistrationKeyListStore: rootStore.agentRegistrationKeyListStore,
    tenantInfoStore: rootStore.tenantInfoStore,
    flagListStore: rootStore.flagListStore,
    applicationListStore: rootStore.applicationListStore,
    applicationSearchListStore: rootStore.applicationSearchListStore,
    statListStore: rootStore.statListStore,
    dwellTimeListStore: rootStore.dwellTimeListStore,
    commentListStore: rootStore.commentListStore,
    notificationListStore: rootStore.notificationListStore,
    adminNotificationListStore: rootStore.adminNotificationListStore,
    settingsStore: rootStore.settingsStore,
    analysisStore: rootStore.analysisStore,
    boxListStore: rootStore.boxListStore,
    loadingStore: rootStore.loadingStore,
    integrationListStore: rootStore.integrationListStore,
    navigationStore: rootStore.navigationStore,
    bmsIntegrationStore: rootStore.bmsIntegrationStore,
    autotaskIntegrationStore: rootStore.autotaskIntegrationStore,
    vsaXIntegrationStore: rootStore.vsaXIntegrationStore,
    dialogStore: rootStore.dialogStore,
    alertListStore: rootStore.alertListStore,
    systemNotificationListStore: rootStore.systemNotificationListStore,
    quarantinedFileListStore: rootStore.quarantinedFileListStore,
    alertSourceStore: rootStore.alertSourceStore,
    reportListStore: rootStore.reportListStore,
    scheduledReportListStore: rootStore.scheduledReportListStore,
    ruleListStore: rootStore.ruleListStore,
    organizationListStore: rootStore.organizationListStore,
    locationListStore: rootStore.locationListStore,
    deviceListStore: rootStore.deviceListStore,
    deviceGroupListStore: rootStore.deviceGroupListStore,
    suppressionRuleListStore: rootStore.suppressionRuleListStore,
    policyListStore: rootStore.policyListStore,
    extensionResponseListStore: rootStore.extensionResponseListStore,
    extensionResponseQueueListStore: rootStore.extensionResponseQueueListStore,
    extensionGlobalVariableListStore: rootStore.extensionGlobalVariableListStore,
    rulePublishHistoryListStore: rootStore.rulePublishHistoryListStore,
    ruleVersionListStore: rootStore.ruleVersionListStore,
    suppressionRulePublishHistoryListStore: rootStore.suppressionRulePublishHistoryListStore,
    suppressionRuleVersionListStore: rootStore.suppressionRuleVersionListStore,
    fileListStore: rootStore.fileListStore,
    fileSearchListStore: rootStore.fileSearchListStore,
    avListStore: rootStore.avListStore,
    avExclusionListStore: rootStore.avExclusionListStore,
    lists: {
        '/admin/webhooks/:webhookId/errors': new StoreWebhookErrorFilters(),
        '/admin/extensions/global-variables': new StoreExtensionGlobalVariableFilters(),
        '/analyze/process/:fileRepId/connections': new StoreProcessConnectionFilters(),
        '/file/process/:fileRepId/connections': new StoreProcessConnectionFilters(),
        '/alerts/list': new StoreAlertFilters(),
        '/alerts/detail/:alertId': new StoreAlertFilters(),
        '/policies/alert-suppression/list': new StoreSuppressionRulesFilters(),
        '/policies/alert-suppression/publish-history': new StoreSuppressionRulePublishHistoryFilters(),
        '/policies/alert-suppression/:suppressionRuleId/view-history': new StoreSuppressionRuleVersionFilters(),
        '/discover/target-groups/:targetGroupId/issues': new StoreAddressIssuesFilters(),
        '/respond/response/list': new StoreExtensionResponseFilters(),
        '/policies/detection-rules/list': new StoreRulesFilters(),
        '/policies/detection-rules/publish-history': new StoreRulePublishHistoryFilters(),
        '/policies/detection-rules/:ruleId/view-history': new StoreRuleVersionFilters()
    },
    breadcrumbStore: rootStore.breadcrumbStore,
    responseOverrideStore: rootStore.responseOverrideListStore,
    tableViewStore: rootStore.tableViewStore
});

/* e.g. ..
{
    user: { name, email, signedIn, isAdmin },
    alerts: { unreadCount: 23 },
    tasks: {
        activeCount: 4
    },
    lists {
        'targetGroup__hosts': { filter, sort }
    }
}
*/
